/*
 *###############################################################################
 *Module Name                   : PromotionMaster.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Dinisuru Balasuriya                           #
 *Date                          : Monday , March 7th 2022, 10:10:07 am          #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */


import React from "react"
import { 
    Col,
    Row, 
    Label
} from "reactstrap"

//**Importing required componant files   */

import DPDropDown from "framework/components/DPDropDown"
import DPDropDownMultiSelect from "framework/components/DPDropDownMultiSelect"

//**End Importing required componant files */


const PromotionExcludeInclude = ({
    setSupplierInclude,
    setSupplierExclude,
    setCustomerInclude,
    setCustomerExclude,
    supplierInclude,
    supplierExclude,
    customerInclude,
    customerExclude,
    customerbundles,
    supplierbundles,
    disabled,
    showAllFields,
    exclAct,
    itemBundleExclude,
    setItemBundleExclude,
    itemBundleInclude,
    setItemBundleInclude,
    groupBundleExclude,
    setGroupBundleExclude,
    groupBundleInclude,
    setGroupBundleInclude,
    allSkubundles,
    allSKUGrpBundles,
    inclAct,
    shwoloyaltyCustomers
}) => {


    return (
        <React.Fragment>
            <Row className="mb-20">
                <Col sm={12} md={6} className="mb-4-sm">

                    {showAllFields ? <Row className="mb-2">
                        <Label >
                            Include
                        </Label>
                    </Row> : null}

                    {showAllFields && shwoloyaltyCustomers ? <DPDropDown
                        selectedGroup={customerInclude}
                        onChange={setCustomerInclude}
                        optionGroup={customerbundles}
                        labelText={'Customer Bundle  '}
                        disabled={disabled}
                    /> : null}



                    {/* {showAllFields && inclAct ? <DPDropDown
                        selectedGroup={supplierInclude}
                        onChange={setSupplierInclude}
                        optionGroup={supplierbundles}
                        labelText={'Supplier Bundle '}
                        disabled={disabled}
                    /> : null} */}



                    {/* {showAllFields && inclAct ? <DPDropDown
                        selectedGroup={itemBundleInclude}
                        onChange={setItemBundleInclude}
                        optionGroup={allSkubundles}
                        labelText={'Item Bundle '}
                        disabled={disabled}
                    /> : null} */}

                    {showAllFields && inclAct ? <DPDropDownMultiSelect
                        selectedGroup={itemBundleInclude}
                        onChange={setItemBundleInclude}
                        optionGroup={allSkubundles}
                        labelText={'Item Bundle '}
                        disabled={disabled}
                    /> : null}


{/* 
                    {showAllFields && inclAct ? <DPDropDown
                        selectedGroup={groupBundleInclude}
                        onChange={setGroupBundleInclude}
                        optionGroup={allSKUGrpBundles}
                        labelText={'Group Bundle '}
                        disabled={disabled}
                    /> : null} */}

                </Col>
                <Col sm={12} md={6} className="mb-4-sm">

                    {showAllFields ? <Row className="mb-2">
                        <Label >
                            Exclude
                        </Label>
                    </Row> : null}


                    {showAllFields && shwoloyaltyCustomers ? <DPDropDown
                        selectedGroup={customerExclude}
                        onChange={setCustomerExclude}
                        optionGroup={customerbundles}
                        labelText={'Customer Bundle  '}
                        disabled={disabled}
                    /> : null}


                    {/* {showAllFields && exclAct ? <DPDropDown
                        selectedGroup={supplierExclude}
                        onChange={setSupplierExclude}
                        optionGroup={supplierbundles}
                        labelText={'Supplier Bundle '}
                        disabled={disabled}
                    /> : null} */}



                    {showAllFields && exclAct ? <DPDropDownMultiSelect
                        selectedGroup={itemBundleExclude}
                        onChange={setItemBundleExclude}
                        optionGroup={allSkubundles}
                        labelText={'Item Bundle '}
                        disabled={disabled}
                    /> : null}



                    {/* {showAllFields && exclAct ? <DPDropDown
                        selectedGroup={groupBundleExclude}
                        onChange={setGroupBundleExclude}
                        optionGroup={allSKUGrpBundles}
                        labelText={'Group Bundle '}
                        disabled={disabled}
                    /> : null} */}

                </Col>
            </Row>
            <Row>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
            </Row>


        </React.Fragment>
    )
}
export default PromotionExcludeInclude

